'use client';

import React, { type ReactNode } from 'react';
import { useLegacyC } from '../theme';
import { space, fontSize, fontWeight, letterSpacing } from '../theme/tokens';

export interface SectionHeaderProps {
  title: string;
  caption?: ReactNode;
  action?: ReactNode;
}

/**
 * Tab-level grouping label. Sits between cards, not inside one.
 *
 * Used to break a flat card stack into named sections (e.g. "Erfassen",
 * "Heute", "Übersicht") so the user gets visible hierarchy instead of
 * a wall of equally-weighted cards. The eyebrow style — uppercase,
 * small, accent-tinted — matches the headline pattern already used
 * inside cards like WorkoutPreviewCard.
 */
export function SectionHeader({ title, caption, action }: SectionHeaderProps) {
  const C = useLegacyC();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        padding: `${space[5]}px ${space[1]}px ${space[2]}px`,
      }}
    >
      <div>
        <div
          style={{
            fontSize: fontSize.sm,
            fontWeight: fontWeight.bold,
            color: C.aink,
            letterSpacing: letterSpacing.wide,
            textTransform: 'uppercase',
          }}
        >
          {title}
        </div>
        {caption && (
          <div
            style={{
              fontSize: fontSize.sm,
              color: C.ts,
              marginTop: 2,
            }}
          >
            {caption}
          </div>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
